import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheckIcon, MapPinIcon, StarIcon } from 'lucide-react';
interface Notification {
  firstName: string;
  lastName: string;
  province: string;
}
const NOTIFICATIONS: Notification[] = [{
  firstName: 'Carlos',
  lastName: 'Méndez',
  province: 'Buenos Aires'
}, {
  firstName: 'Roberto',
  lastName: 'García',
  province: 'Córdoba'
}, {
  firstName: 'Miguel',
  lastName: 'Torres',
  province: 'Rosario'
}, {
  firstName: 'Fernando',
  lastName: 'López',
  province: 'Mendoza'
}, {
  firstName: 'Alejandro',
  lastName: 'Ruiz',
  province: 'Tucumán'
}, {
  firstName: 'Pablo',
  lastName: 'Sánchez',
  province: 'Santa Fe'
}, {
  firstName: 'Gustavo',
  lastName: 'Díaz',
  province: 'La Plata'
}, {
  firstName: 'Martín',
  lastName: 'Fernández',
  province: 'Salta'
}, {
  firstName: 'Ricardo',
  lastName: 'Pérez',
  province: 'Neuquén'
}, {
  firstName: 'Jorge',
  lastName: 'Martínez',
  province: 'Chaco'
}];
export function SocialProofPopup() {
  const [currentNotification, setCurrentNotification] = useState<Notification | null>(null);
  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      showRandomNotification();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showRandomNotification = () => {
    const randomIdx = Math.floor(Math.random() * NOTIFICATIONS.length);
    setCurrentNotification(NOTIFICATIONS[randomIdx]);
    setTimeout(() => {
      setCurrentNotification(null);
      const nextDelay = Math.floor(Math.random() * 3000) + 5000;
      setTimeout(showRandomNotification, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-374">
      {currentNotification && <motion.div initial={{
      opacity: 0,
      y: 30,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-3 left-3 z-50 bg-[#0d1530]/95 backdrop-blur-md rounded-lg shadow-[0_0_15px_rgba(22,163,74,0.3)] border-2 border-emerald-500/50 p-2.5 pr-4 max-w-[260px]" data-id="element-375">
          <div className="absolute -top-1.5 -right-1.5 flex items-center gap-0.5 bg-[#16a34a] text-black text-[9px] font-black px-1.5 py-0.5 rounded-full shadow-md uppercase tracking-wider" data-id="element-376">
            <BadgeCheckIcon className="w-3 h-3" data-id="element-377" />
            <span data-id="element-378">Verificado</span>
          </div>

          <div className="flex items-center gap-2" data-id="element-379">
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center text-black text-xs font-black flex-shrink-0 shadow-sm" data-id="element-380">
              {currentNotification.firstName[0]}
              {currentNotification.lastName[0]}
            </div>

            <div className="min-w-0" data-id="element-381">
              <p className="text-sm font-black text-white leading-tight truncate" data-id="element-382">
                {currentNotification.firstName} {currentNotification.lastName}
              </p>

              <div className="flex items-center gap-1.5 mt-0.5" data-id="element-383">
                <span className="flex items-center gap-px" data-id="element-384">
                  {[1, 2, 3, 4, 5].map(s => <StarIcon key={s} className="w-2.5 h-2.5 text-yellow-400 fill-yellow-400" data-id="element-385" />)}
                </span>
                <span className="flex items-center gap-0.5 text-[10px] text-[#4ade80] font-bold leading-tight uppercase tracking-wider" data-id="element-386">
                  <MapPinIcon className="w-3 h-3 flex-shrink-0" data-id="element-387" />
                  {currentNotification.province}
                </span>
              </div>

              <p className="text-[10px] text-gray-300 leading-tight mt-1 font-medium" data-id="element-388">
                Compró el Mega Pack Maestro Cerrajero
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}